import React, { Component, createContext, useContext } from 'react'
import { useUpdateEntitiesCache } from 'state/entities'
import { get, patch, remove } from 'api'

const CompetenceTypeContext = createContext()
CompetenceTypeContext.displayName = 'CompetenceType'

class CompetenceTypeProvider extends Component {
    constructor(props) {
        super(props)

        this.setId(props.id)

        this.state = {
            type: null,
            deleted: false,

            fetchType: this.fetch,
            updateType: this.update,
            removeType: this.remove
        }
    }

    componentDidMount() {
        const { fetchOnMount = true } = this.props
        fetchOnMount && this.fetch()
    }

    componentDidUpdate({ id }) {
        if(id !== this.props.id) {
            this.setId(this.props.id)
            this.replace()
        }
    }

    setId = id => this.id = id

    fetch = async () => {
        const { response: type, ok } = await get({ path: `/competence-types/${this.id}` })
        !!ok && this.setState({ type })
    }

    update = async (body, id) => {
        const { ok, response: type } = await patch({
            path: `/competence-types/${id}`,
            body
        })

        if(ok && type) {
            this.setState({ type })
            this.props.updateEntitiesCache('invalidateQueries', ['competence', 'types'])
        }

        return { ok, response: type }
    }

    remove = async (id, params = {}) => {
        const { ok } = await remove({
            path: `/competence-types/${id}`,
            params,
            returnsData: false
        })

        if(ok) {
            this.setState({ deleted: true })
            this.props.updateEntitiesCache('invalidateQueries', ['competence', 'types'])
        }

        return { ok }
    }

    replace = () => this.setState({ type: null }, this.fetch)

    render() {
        const { children = null } = this.props

        return (
            <CompetenceTypeContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </CompetenceTypeContext.Provider>
        )
    }
}

export const useCompetenceType = () => useContext(CompetenceTypeContext)

export default props => {
    const updateEntitiesCache = useUpdateEntitiesCache()

    return (
        <CompetenceTypeProvider
            {...props}
            updateEntitiesCache={updateEntitiesCache} />
    )
}